export default __webpack_public_path__ + "static/media/river.4c9fa3c7.mp3";